import { addFilterScopeHandler } from './AddFilterScopeStmt';
import { aclAllowScopeHandler } from './AllowRoleScopeStmt';
import { createScopeHandler } from './CreateScopeStmt';
import { aclDenyScopeHandler } from './DenyRoleScopeStmt';
import { removeFilterScopeHandler } from './RemoveFilterScopeStmt';
import { removeScopeHandler } from './RemoveScopeStmt';
export * from './AllowRoleScopeStmt';
export * from './AddFilterScopeStmt';
export * from './CreateScopeStmt';
export * from './DenyRoleScopeStmt';
export * from './RemoveFilterScopeStmt';
export * from './RemoveScopeStmt';
export * from './scopeInstruction';
export const scopeHandlers = [addFilterScopeHandler, aclAllowScopeHandler, createScopeHandler, aclDenyScopeHandler, removeFilterScopeHandler, removeScopeHandler];
//# sourceMappingURL=index.js.map